import { render, staticRenderFns } from "./OrderTypes.vue?vue&type=template&id=e60a33e4&"
import script from "./OrderTypes.vue?vue&type=script&lang=js&"
export * from "./OrderTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports